import { gql } from 'graphql-tag';

export const DEVELOPMENT_DETAILS_QUERY = gql`
    query DevelopmentDetails($id: Int!, $deprecatedBranchId: Int!) {
        newHomesDevelopmentData(
            id: $id
            deprecatedBranchId: $deprecatedBranchId
        ) {
            bedrooms
            name
            images
            listingsDetails {
                listings {
                    balcony
                    parking
                    terrace
                    garage
                    garden
                    counts {
                        numBathrooms
                        numBedrooms
                        numLivingRooms
                    }
                    pricing {
                        label
                    }
                    listingId
                    propertyType
                    section
                }
            }
        }
    }
`;
